export default 'encounterablePage';
